<template>
  <q-dialog v-model="aberto" persistent>
    <q-card style="min-width: 480px; max-width: 580px; border-radius: 12px">
      <!-- Cabeçalho -->
      <q-card-section class="row items-center q-pb-none">
        <div class="col">
          <div class="text-h6 text-brand-1 text-weight-bold">
            Que pena que ainda não conseguiu agendar! 😕
          </div>
          <div class="text-caption text-grey-6 q-mt-xs">
            Mas ainda temos algumas alternativas para você
          </div>
        </div>
        <q-btn icon="close" flat round dense @click="fechar" />
      </q-card-section>

      <q-separator class="q-mt-sm" />

      <!-- Conteúdo -->
      <q-card-section class="q-pt-md" v-if="!mensagemVideos">
        <p class="text-body2 text-grey-7">
          Sabemos que conciliar agendas pode ser difícil. Que tal tentar um
          horário diferente no nosso calendário, ou entrar em contato direto com
          o nosso time pelo WhatsApp?
        </p>
      </q-card-section>

      <q-separator v-if="!mensagemVideos" />

      <!-- Opções -->
      <q-card-section v-if="!mensagemVideos" class="q-gutter-sm q-pt-md">
        <!-- Opção 1: Calendário -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 1 }"
          @click="opcaoCalendario"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon name="event" size="28px" color="primary" class="q-mr-md" />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Quero tentar agendar novamente
              </div>
              <div class="text-caption text-grey-6">
                Veja os horários disponíveis no nosso calendário
              </div>
            </div>
            <q-spinner v-if="loadingOpcao === 1" color="primary" size="20px" />
          </q-card-section>
        </q-card>

        <!-- Opção 2: WhatsApp -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 2 }"
          @click="opcaoWhatsApp"
        >
          <q-card-section class="row items-center q-py-sm">
            <img
              src="../assets/whatsapp.png"
              width="28"
              height="28"
              class="q-mr-md"
              style="flex-shrink: 0"
            />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Chamar o time no WhatsApp
              </div>
              <div class="text-caption text-grey-6">
                Fale diretamente com a equipe e agende pelo chat
              </div>
            </div>
            <q-spinner v-if="loadingOpcao === 2" color="positive" size="20px" />
          </q-card-section>
        </q-card>

        <!-- Opção 3: Vídeos -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 3 }"
          @click="opcaoVideos"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon
              name="play_circle_outline"
              size="28px"
              color="deep-orange"
              class="q-mr-md"
            />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Mudei de ideia — quero assistir aos vídeos
              </div>
              <div class="text-caption text-grey-6">
                Realize o treinamento no seu próprio ritmo
              </div>
            </div>
            <q-spinner
              v-if="loadingOpcao === 3"
              color="deep-orange"
              size="20px"
            />
          </q-card-section>
        </q-card>

        <!-- Opção 4: Dispensar -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 4 }"
          @click="opcaoDispensar"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon
              name="thumb_up_off_alt"
              size="28px"
              color="teal"
              class="q-mr-md"
            />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Não preciso do treinamento agora
              </div>
              <div class="text-caption text-grey-6">
                Esta mensagem não será mais exibida para você
              </div>
            </div>
            <q-spinner v-if="loadingOpcao === 4" color="teal" size="20px" />
          </q-card-section>
        </q-card>
      </q-card-section>

      <!-- Mensagem pós vídeos -->
      <q-card-section v-if="mensagemVideos" class="q-pt-md text-center">
        <q-icon
          name="mark_email_read"
          size="48px"
          color="primary"
          class="q-mb-md"
        />
        <p class="text-body1 text-brand-1 text-weight-bold">
          Ótimo! Nossa equipe já foi notificada.
        </p>
        <p class="text-body2 text-grey-7">
          Em breve você receberá um e-mail com os links dos vídeos de
          treinamento e materiais de apoio para consultar no seu ritmo.
        </p>
        <q-btn
          label="Fechar"
          no-caps
          style="background-color: #21324a; border-radius: 8px; color: white"
          class="q-mt-sm"
          @click="fechar"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { avisoTreinamentoService } from "../services/avisoTreinamentoService";

const CALENDAR_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0H7LwFcOAL-TVrk0RNCKmPJs2zCg0ou_Vjh7Fq6CT7wJufOhmw0ABXVPwP3KLDXvGmUnhcnnP1";
const WHATSAPP_URL = "https://wa.me/5511930315382";

export default {
  name: "AvisoTreinamentoCalendarioVencidoModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    userEmail: {
      type: String,
      default: "",
    },
    docId: {
      type: String,
      default: null,
    },
    userSap: {
      type: String,
      default: null,
    },
    userName: {
      type: String,
      default: null,
    },
    tipoTreinamentoWeb: {
      type: String,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const aberto = ref(props.modelValue);
    const loadingOpcao = ref(null);
    const mensagemVideos = ref(false);

    watch(
      () => props.modelValue,
      (val) => {
        aberto.value = val;
      }
    );

    watch(aberto, (val) => {
      emit("update:modelValue", val);
    });

    const fechar = () => {
      aberto.value = false;
    };

    const executarOpcao = async (opcao, motivo, callback) => {
      loadingOpcao.value = opcao;
      await avisoTreinamentoService.notificarWebhook(
        motivo,
        props.userEmail,
        null,
        props.docId,
        props.userSap,
        props.userName,
        props.tipoTreinamentoWeb
      );
      if (callback) callback();
      loadingOpcao.value = null;
      fechar();
    };

    const opcaoCalendario = () => {
      executarOpcao(1, "calendario_vencido_reagendar", () => {
        window.open(CALENDAR_URL, "_blank");
      });
    };

    const opcaoWhatsApp = () => {
      executarOpcao(2, "calendario_vencido_whatsapp", () => {
        window.open(WHATSAPP_URL, "_blank");
      });
    };

    const opcaoVideos = async () => {
      loadingOpcao.value = 3;
      await avisoTreinamentoService.notificarWebhook(
        "videos",
        props.userEmail,
        null,
        props.docId,
        props.userSap,
        props.userName,
        props.tipoTreinamentoWeb
      );
      loadingOpcao.value = null;
      mensagemVideos.value = true;
    };

    const opcaoDispensar = () => {
      executarOpcao(4, "confortavel");
    };

    return {
      aberto,
      loadingOpcao,
      mensagemVideos,
      fechar,
      opcaoCalendario,
      opcaoWhatsApp,
      opcaoVideos,
      opcaoDispensar,
    };
  },
};
</script>

<style scoped>
.opcao-card {
  border-radius: 8px !important;
  transition: background-color 0.2s;
}
.opcao-card:hover {
  background-color: #f5f7fa;
}
.opcao-loading {
  opacity: 0.7;
  pointer-events: none;
}
</style>
